module.exports = __webpack_public_path__ + "static/media/idea.9f812055.svg";